export class CompanyDataList {
    constructor(companyRepository) {
      this.companyRepository = companyRepository;
    }
  
    async execute() {
      console.log('I am in companylist usecase');
      return await this.companyRepository.getCompanyList();
    }
  }